import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { QUEBEC } from '../../../../../src/shared/i18n';
import Translation from '../../../../components/stateless/Translation';
import SMHoursTable from '../SMHoursTable';
import SMHoursTableCurrentDay from '../SMHoursTableCurrentDay';

const propTypes = {
  facility: PropTypes.shape({
    name: PropTypes.string.isRequired,
    hours: PropTypes.shape({
      office: PropTypes.object,
      access: PropTypes.object,
    }).isRequired,
    settings: PropTypes.shape({
      twentyFourHourPassport: PropTypes.bool.isRequired,
    }).isRequired,
    timezone: PropTypes.string,
  }),
};

const defaultProps = {
  facility: undefined,
};

const StorageMartHours = ({ facility }) => {
  if (!facility) {
    return false;
  }
  const [showHours, setShowHours] = useState(false);
  const [showLocationHours, setShowLocationHours] = useState(true);
  const {
    hours: { office, access },
    address: { state },
    settings: { twentyFourHourPassport },
  } = facility;

  const use24HourTime = state === QUEBEC;

  const toggleHours = () => setShowHours(!showHours);


  const toggleLocationHours = () => {
    setShowLocationHours(prev => !prev);
  };

  const caretClass = showHours ? 'up' : 'down';
  return (
    <>
      <div className="border-b border-custom-gray border-b-[1px]">
        <button onClick={toggleHours} aria-expanded={showHours} type="button" aria-label="Expand store hours" className="hoursClick flex gap-2 items-center justify-between py-4 px-[.75rem] w-full text-left  hover:bg-gray-100">
          <div className="flex gap-2 items-start justify-between w-full">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" role="presentation">
                <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
              </svg>
            </div>
            <div className="w-full">
              <div className="leading-custom-1.2">
                <span className="font-bold text-black">
                  <Translation id="widgets.hours.gate" defaultMessage="Access" />{': '}
                </span>
                <SMHoursTableCurrentDay
                  title="Access"
                  hours={access.hours}
                  use24HourTime={use24HourTime}
                  timezone={facility.timezone}
                  useColors
                />
              </div>
              <div className="text-gray-600 text-sm" data-storeHour>
                <Translation id="widgets.hours.office" defaultMessage="Office" />{': '}
                <SMHoursTableCurrentDay
                  title="Office"
                  hours={office.hours}
                  use24HourTime={use24HourTime}
                  timezone={facility.timezone}
                  useColors={false}
                />
              </div>
            </div>
          </div>
          <div>
            <i
              className={`fa fa-chevron-${caretClass} text-[18px] text-black`}
              aria-hidden="true"
            />
          </div>
        </button>

        {showHours && (
          <div className="p-4 border-t border-custom-gray border-t-[1px]">
            <div className="relative w-full mb-4 rounded-md border h-10 bg-gray-200 hover:bg-gray-300" role="radiogroup" aria-label="Hour Display">
              <span className={`bg-black shadow flex items-center justify-center w-1/2 rounded h-full transition-all duration-150 ease-linear top-0 absolute ${showLocationHours ? 'left-0' : 'left-1/2'}`} />

              <div className="relative w-full h-full flex items-center">
                <button
                  onClick={toggleLocationHours}
                  type="button"
                  role="radio"
                  aria-checked={showLocationHours}
                  aria-label="Toggle office hours"
                  className={`w-full flex justify-center text-black cursor-pointer ${showLocationHours && 'text-white font-bold'}`}
                >
                  <Translation id="widgets.hours.gate" defaultMessage="Access" />
                </button>
                <button
                  onClick={toggleLocationHours}
                  type="button"
                  role="radio"
                  aria-checked={!showLocationHours}
                  aria-label="Toggle location hours"
                  className={`w-full flex justify-center text-black cursor-pointer ${!showLocationHours && 'text-white font-bold'}`}
                >
                  <Translation id="widgets.hours.office" defaultMessage="Office" />
                </button>
              </div>
            </div>
            {!showLocationHours && (

              <SMHoursTable
                typeId="officeHours"
                note={office.note}
                hours={office.hours}
                use24HourTime={use24HourTime}
                timezone={facility.timezone}
              />
            )}
            {showLocationHours && (
              <SMHoursTable
                typeId="gateHours"
                note={access.note}
                hours={access.hours}
                use24HourTime={use24HourTime}
                accessPassport={twentyFourHourPassport}
                timezone={facility.timezone}
              />
            )}
          </div>
        )
        }
      </div>
    </>
  );
};

StorageMartHours.propTypes = propTypes;
StorageMartHours.defaultProps = defaultProps;

export default StorageMartHours;
